export const MEMBERS_AREA_APP_DEF_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
export const MEMBERS_AREA_ON_MSB_APP_DEF_ID = 'b976560c-3122-4351-878f-453f337b7245';
export const MY_ACCOUNT_APP_DEF_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
export const SOCIAL_GROUPS_APP_ID = '148c2287-c669-d849-d153-463c7486a694';
export var LifecycleEvent;
(function (LifecycleEvent) {
    LifecycleEvent["IntegrationStart"] = "integrationStart";
    LifecycleEvent["IntegrationFinish"] = "integrationFinish";
    LifecycleEvent["MembersAreaInstallStart"] = "membersAreaInstallStart";
    LifecycleEvent["MembersAreaInstallFinish"] = "membersAreaInstallFinish";
    LifecycleEvent["IntegratedAppsInstallStart"] = "integratedAppsInstallStart";
    LifecycleEvent["IntegratedAppsInstallFinish"] = "integratedAppsInstallFinish";
})(LifecycleEvent || (LifecycleEvent = {}));
export const defaultIntegrationOptions = {
    installAutomatically: true,
    installAppsAutomatically: true,
    membersAreaApps: [],
    membersAreaAppsOptions: [],
    experimentOptions: undefined,
    experimentalOverride: undefined,
    onEvent: undefined,
    reportErrors: false,
};
//# sourceMappingURL=constants.js.map